export const farmerPartnerInfo = {
  clientId: "",
  farmPartnerName: "",
  storeName: "",
  email: "",
  contactNumber: "",
  alternateContactNumber: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  pincode: "",
  latitude: 0.0,
  longitude: 0.0,
  serviceRadiusKm: 0.0,
  serviceAreaName: "",
  isActive: false,
  isAvailable: false,
  openingTime: "",
  closingTime: "",

  village: "",
  landmark: "",
  gstNumber: "",
  profileImage: "",
  notes: "",
};
